/*******************************************************************************
  siteStatusValidation.js

  Author: Advait;
*******************************************************************************/

const validModes = ["IDLE", "INSPECTION", "SECURITY_PATROL", "RECEPTIONIST", "DISINFECTION"];
const validHealth = ["OK", "OK_WARN"];
const rmsReachableErrors = [
  "econnrefused",
  "ehostunreach",
  "etimedout",
  "enotfound",
  "networkerror",
];
const rmsAuthErrors = ["401", "403", "forbidden", "unauthorized"];

export const validateRMSStatus = (status) => {
  // Check for specific RMS connection errors FIRST
  if (status?.error) {
    const errorStr = status.error.toLowerCase();
    // Network/DNS errors - RMS is unreachable
    if (rmsReachableErrors.some((err) => errorStr.includes(err))) {
      return [false, `The domain is unreachable${contactSupportText()}`];
    }
    // Authentication errors - invalid credentials
    if (rmsAuthErrors.some((err) => errorStr.includes(err))) {
      return [false, `Domain credentials are invalid${contactSupportText()}`];
    }
    // There may be other errors indicating RMS is reachable but some other issue
    // Check if we have siteinfo in the response - that means we got past RMS auth
    if (status.siteinfo) {
      return [true, "Connected"]; // Connected
    }
    return [false, ""];
  }

  // If we got a response without error, RMS connection is valid
  // (even if robot is not found or disconnected from RMS)
  return [true, "Connected"];
};

export const validateModeStatus = (mode) => {
  // if mode exists in validModes array, return true
  if (validModes.includes(mode)) return [true, ""];
  return [
    false,
    mode === "MAINTENANCE"
      ? `Ava is in maintenance mode${contactSupportText(true)}`
      : `Invalid mode: ${mode}${contactSupportText()}`,
  ];
};

export const validateHealthStatus = (overallHealth, healthDetails) => {
  // if the health exists in validHealth array, return true
  if (validHealth.includes(overallHealth)) return [true, ""];

  // UNLOCALIZED is a warning state
  if (overallHealth === "UNLOCALIZED") {
    return [false, `Ava does not know its location${contactSupportText(true)}`];
  }

  // If health is not OK, OK_WARN, check for specific faulty components
  let faultyComponents = [];
  if (overallHealth !== "OK" && overallHealth !== "OK_WARN" && healthDetails) {
    faultyComponents = Object.entries(healthDetails)
      .filter(([key, value]) => key !== "AudioIn" && value !== "OK" && value !== "OK_WARN")
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  }
  return [false, `Ava has health issue ${faultyComponents}${contactSupportText()}`];
};

export const contactSupportText = (tenantAdminSupport = false) => {
  return `, please contact ${tenantAdminSupport ? "your administrator" : "Ava Robotics Support"}`;
};
